<template>
  <div>
    来店者割合
    <el-form :model="form" inline>
      <el-date-picker
        v-model="form.date">
      </el-date-picker>
      <el-select v-model="form.shop">
        <el-option
          v-for="shop in shops"
          :key="shop.pk"
          :label="shop.name"
          :value="shop.pk">
        </el-option>
      </el-select>
      <el-button
        type="primary"
        :disabled="!form.shop"
        @click="fetchData(false)">表示</el-button>
    </el-form>
    <el-row v-loading="isLoading" v-show="searched">
      <el-col :span="8">
        <div>
          施術情報
          <table class="data-table">
            <tr>
              <td>施術数</td>
              <td>{{ data.doneCount }}</td>
            </tr>
            <tr>
              <td>キャンセル数</td>
              <td>{{ data.cancelCount }}</td>
            </tr>
            <tr>
              <td>削除数</td>
              <td>{{ data.deleteCount }}</td>
            </tr>
            <tr>
              <td>no-show数</td>
              <td>{{ data.noShowCount }}</td>
            </tr>
          </table>
        </div>
      </el-col>
      <el-col :span="8">
        <div>
          顧客内訳
          <table class="data-table">
            <tr>
              <td>firstVisitor</td>
              <td>{{ data.firstVisitor }}</td>
            </tr>
            <tr>
              <td>ハッピーターン</td>
              <td>{{ data.happyTurn }}</td>
            </tr>
            <tr>
              <td>ロイヤルターン</td>
              <td>{{ data.royalTurn }}</td>
            </tr>
          </table>
        </div>
      </el-col>
      <el-col :span="8">
        <div>
        シフト状況
          <table class="data-table">
            <tr>
              <td>スタッフ数</td>
              <td>{{ data.staffCount }}</td>
            </tr>
            <tr>
              <td>予定シフト時間</td>
              <td>{{ data.shiftMinutes|printTime }}</td>
            </tr>
            <tr>
              <td>予定実働時間</td>
              <td>{{ data.workMinutes|printTime }}</td>
            </tr>
            <tr>
              <td>予定休憩時間</td>
              <td>{{ data.breakMinutes|printTime }}</td>
            </tr>
            <tr>
              <td>予定ブロック時間</td>
              <td>{{ data.blockMinutes|printTime }}</td>
            </tr>
            <tr>
              <td>シフト時間(実績)</td>
              <td>{{ data.realShiftMinutes|printTime }}</td>
            </tr>
            <tr>
              <td>実働時間(実績)</td>
              <td>{{ data.realWorkMinutes|printTime }}</td>
            </tr>
            <tr>
              <td>休憩時間(実績)</td>
              <td>{{ data.realBreakMinutes|printTime }}</td>
            </tr>
          </table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment'
import ShopType from '@/consts/ShopType'

export default {
  name: 'AnalyticsDaily',
  data () {
    return {
      searched: false,
      form: {
        date: null,
        shop: null,
      },
      shops: [],
      data: {
        doneCount: 0,
        deleteCount: 0,
        cancelCount: 0,
        noShowCount: 0,
        firstVisitor: 0,
        happyTurn: 0,
        royalTurn: 0,
        staffCount: 0,
        shiftMinutes: 0,
        workMinutes: 0,
        blockMinutes: 0,
        breakMinutes: 0,
        realWorkMinutes: 0,
        realShiftMinutes: 0,
        realBreakMinutes: 0,
      },
      isLoading: false,
    }
  },
  filters: {
    printTime (val) {
      if (!val) {
        return '-'
      }
      const hour = Math.floor(val / 60)
      const minute = val % 60
      return `${hour}時間${minute}分 (${val}分)`
    },
  },
  methods: {
    fetchShopData () {
      this.$request.shops.list().then(res => {
        this.shops = res.body.results.filter(x => x.shopType === ShopType.SHOP)
      })
    },
    fetchData () {
      this.searched = true
      this.isLoading = true
      const date = moment(this.form.date).format('YYYY-MM-DD')
      this.$request.analytics.daily(date, this.form.shop).then(res => {
        this.data = res.body
      }).finally(() => {
        this.isLoading = false
      })
    },
  },
  mounted () {
    this.form.date = moment().format('YYYY-MM-DD')
    this.fetchShopData()
  },
}
</script>

<style scoped>
.data-table {
  border: 1px solid #dee2ed;
  border-collapse: collapse;
}

.data-table td {
  border: 1px solid #dee2ed;
}
</style>



// WEBPACK FOOTER //
// src/components/Analytics/Daily.vue